import React from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import DocsHelper from "util/DocsHelper";
import DataLakeRetrievalsList from "./DataLakeRetrievalsList";
import DataLakeJobs from "../components/DataLakeJobs";
const DataLakeRetrievalsPage = () => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("retrievals_page.title") }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("retrievals_page.title"),
      documentationLink: {
        title: t("retrievals_page.documentation_link"),
        path: DocsHelper.PAGES.DATA_LAKE
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("retrievals_page.description"))
  ), /* @__PURE__ */ React.createElement(DataLakeJobs, null), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(DataLakeRetrievalsList, null))));
};
export default DataLakeRetrievalsPage;
